import config from 'const/config'
import i18n from 'strings/i18n'
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents'
import { Button as BrandRefreshButton } from '@syf-cl/button'
import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import { isBrandRefreshEnabled } from 'helpers/getBrandRefreshPhase'
import AddAccountScreen from '../AddAccountScreen'
import { ManageFormHelpers, ScreenType } from '../typings'
import AddAccountResponseScreen from '../AddAccountResponseScreen'
import { getButtonDetails } from './getButtonDetails'
import { getAnalyticsData } from './getAnalyticsData'
import { FooterWrapper } from '../subcomponents'

const getErrorScreen = (screenType: ScreenType) => {
  let image = ''
  let title = ''
  let description = ''

  const assetUrlBase = `${config.ASSETS_HOST}/assets/vista`

  switch (screenType) {
    case 'Success':
      image = `${assetUrlBase}/add_account_success.png`
      title = `${i18n({ addAccountModal: 'successTitle' })}`
      description = `${i18n({ addAccountModal: 'successDescription' })}`
      break

    case 'MaxAttempt':
      image = `${assetUrlBase}/max_attempts.svg`
      title = `${i18n({ addAccountModal: 'maxAttemptsTitle' })}`
      description = `${i18n({ addAccountModal: 'maxAttemptsDescription' })}`
      break

    case 'AlreadyAdded':
      image = `${assetUrlBase}/add_account_success.png`
      title = `${i18n({ addAccountModal: 'alreadyAddedTitle' })}`
      description = `${i18n({ addAccountModal: 'alreadyAddedDescription' })}`
      break

    case 'UnableToAdd':
      image = `${assetUrlBase}/PlugDisconnect.svg`
      title = `${i18n({ addAccountModal: 'unableToAddTitle' })}`
      description = `${i18n({ addAccountModal: 'unableToAddMessage' })}`
      break

    case 'SomethingWrongForThisAccount':
      image = `${assetUrlBase}/PlugDisconnect.svg`
      title = `${i18n({ addAccountModal: 'syfIDErrorTitle' })}`
      description = `${i18n({ addAccountModal: 'callCustomerService' })}`
      break

    case 'NotSupported':
      image = `${assetUrlBase}/max_attempts.svg`
      title = `${i18n({ addAccountModal: 'notSupportedTitle' })}`
      description = `${i18n({ addAccountModal: 'notSupportedDescription' })}`
      break

    case 'SomethingWrong':
      image = `${assetUrlBase}/PlugDisconnect.svg`
      title = `${i18n({ addAccountModal: 'somethingWrongTitle' })}`
      description = `${i18n({ errors: 'pleaseTryAgain' })}`
      break

    default:
      break
  }

  return (
    <AddAccountResponseScreen
      image={image}
      title={title}
      description={description}
    />
  )
}

export const renderScreen = (
  screenType: ScreenType,
  manageFormState: ManageFormHelpers,
  handleAddCard: () => Promise<void>,
  handleClose: () => void
) => {
  const {
    formData,
    formError,
    setFormError,
    handleInputChange,
    validateInput
  } = manageFormState

  const {
    primaryButtonText,
    secondaryButtonText,
    handlePrimarybuttonClick,
    handleSecondarybuttonClick
  } = getButtonDetails(screenType, handleAddCard, handleClose)

  const {
    buttonDetails: {
      dataReasonPrimary,
      dataReasonSecondary,
      dataTypePrimary,
      dataTypeSecondary
    }
  } = getAnalyticsData(screenType)

  const brandRefreshEnabled = isBrandRefreshEnabled()
  const FooterButton: React.ElementType = brandRefreshEnabled
    ? BrandRefreshButton
    : CLButton
  const primaryVariantProps = brandRefreshEnabled
    ? { variant: 'primary' }
    : { buttonType: 'primary' }
  const secondaryVariantProps = brandRefreshEnabled
    ? { variant: 'tertiary' }
    : { buttonType: 'ghost' }

  return (
    <>
      {(['Default', 'IncorrectInfo'] as ScreenType[]).includes(screenType) ? (
        <AddAccountScreen
          formData={formData}
          formError={formError}
          handleInputChange={handleInputChange}
          validateInput={validateInput}
          setFormError={screenType === 'IncorrectInfo' && setFormError}
          shouldShowIncorrectInfoError={screenType === 'IncorrectInfo'}
        />
      ) : (
        getErrorScreen(screenType)
      )}
      <FooterContainer>
        <FooterWrapper>
          {handleSecondarybuttonClick && (
            <FooterButton
              {...secondaryVariantProps}
              onClick={handleSecondarybuttonClick}
              data-test="modal-footer-secondary-button"
              data-object="button"
              data-reason={dataReasonSecondary}
              data-type={dataTypeSecondary}
            >
              {secondaryButtonText}
            </FooterButton>
          )}
          <FooterButton
            {...primaryVariantProps}
            onClick={handlePrimarybuttonClick}
            data-test="modal-footer-primary-button"
            data-object="button"
            data-reason={dataReasonPrimary}
            data-type={dataTypePrimary}
          >
            {primaryButtonText}
          </FooterButton>
        </FooterWrapper>
      </FooterContainer>
    </>
  )
}
